import React, { useEffect } from 'react';
import useAccessibleDialog from '../../hooks/useAccessibleDialog';
import StatusBadge from '../StatusBadge';
import ShippingDocuments from '../ShippingDocuments';
import { trackingUrl } from '../../utils/trackingUrl';

export default function DistributorShipmentDialog({
  shipment,
  status,
  adminDistributorId,
  onClose,
  t,
}) {
  const { dialogRef, titleId } = useAccessibleDialog({ open: true, onClose });
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, []);
  const tracking = trackingUrl(shipment.carrier, shipment.trackingNumber);
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4">
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        className="me-dw-card me-dw-shipment-dialog flex max-h-[90dvh] w-full max-w-xl flex-col overflow-hidden"
      >
        <header className="flex shrink-0 items-start justify-between gap-4 border-b border-[#e1ebeb] px-5 py-4">
          <div className="min-w-0">
            <h2 id={titleId} className="text-lg font-bold text-[#153d48]">
              {t('Shipment details')}
            </h2>
            <p className="mt-1 break-words text-sm text-[#5e737a]">
              {shipment.order?.orderId || shipment.orderId || t('Record')}
            </p>
          </div>
          <button type="button" className="me-dw-link min-h-[44px] px-2" onClick={onClose}>
            {t('Close')}
          </button>
        </header>
        <section
          aria-label={t('Activity detail')}
          className="min-h-0 space-y-4 overflow-y-auto p-5 text-sm"
        >
          <p>
            {t('Status')}: <StatusBadge status={status} />
          </p>
          <p className="break-words">
            {t('Tracking')}:{' '}
            {tracking ? (
              <a
                href={tracking}
                target="_blank"
                rel="noopener noreferrer"
                className="me-dw-link underline"
              >
                {shipment.trackingNumber}
              </a>
            ) : (
              shipment.trackingNumber || t('Not set')
            )}
          </p>
          <ShippingDocuments shipmentId={shipment._id} adminDistributorId={adminDistributorId} />
        </section>
      </div>
    </div>
  );
}
